"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
var aos_1 = __importDefault(require("aos"));
var AosScroll = /** @class */ (function () {
    function AosScroll() {
        this.windowYScroll = 0;
        this.desktopNav = null;
        this.jobDetailFooter = null;
        aos_1.default.init({
            duration: 600,
            easing: 'ease-out-sine'
        });
        this.addScrollEvents();
        this.desktopNav = document.querySelector('#desktop-navigation');
        this.jobDetailFooter = document.querySelector('#job-detail-footer');
    }
    AosScroll.prototype.addScrollEvents = function () {
        var self = this;
        window.addEventListener('scroll', function () {
            self.windowYScroll = window.scrollY;
            if (self.windowYScroll > 50) {
                if (self.desktopNav && !self.desktopNav.classList.contains(AosScroll.NAV_ACTIVE)) {
                    self.desktopNav.classList.add(AosScroll.NAV_ACTIVE);
                }
                if (self.jobDetailFooter && !self.jobDetailFooter.classList.contains(AosScroll.JOB_ACTIVE)) {
                    self.jobDetailFooter.classList.add(AosScroll.JOB_ACTIVE);
                }
            }
            else {
                if (self.desktopNav && self.desktopNav.classList.contains(AosScroll.NAV_ACTIVE)) {
                    self.desktopNav.classList.remove(AosScroll.NAV_ACTIVE);
                }
                if (self.jobDetailFooter && self.jobDetailFooter.classList.contains(AosScroll.JOB_ACTIVE)) {
                    self.jobDetailFooter.classList.remove(AosScroll.JOB_ACTIVE);
                }
            }
        });
    };
    AosScroll.NAV_ACTIVE = 'navigation--active';
    AosScroll.JOB_ACTIVE = 'job-footer--active';
    return AosScroll;
}());
exports.default = AosScroll;
